<template>
    <el-dialog
            title="录音"
            :visible.sync="dialogVisible"
            :append-to-body="true"
            width="532px"
            :before-close="handleClose">
        <div>
            <div v-if="index === 1" class="page-one">
                <img v-if="['initial'].includes(step)" class="img" :src="$images.luyin.luyin" alt="img" />
                <img @click="handleClickPause" v-if="['start'].includes(step)" class="img cur" :src="$images.luyin.zanting" alt="img" />
                <p class="row" :class="{initial: time === 0}"><span class="name">录制时间</span> <span class="time">{{newTime | filterTime}}</span></p>
                <div class="btns">
                    <p class="one">
                        <span v-if="['initial'].includes(step)" class="btn start" @click="handleClickStart">开始录音</span>
                        <span v-if="['start'].includes(step)" class="btn pause" @click="handleClickPause">暂停录音</span>
                    </p>
                </div>
            </div>
            <div v-if="index === 2" class="page-one">
                <img @click="handleClickResume" class="img cur" :src="$images.luyin.bofang" alt="img" />
                <p class="row" :class="{initial: time === 0}"><span class="name">录制时间</span> <span class="time">{{newTime | filterTime}}</span></p>
                <div class="btns">
                    <p class="one">
                        <el-button v-if="!isPlay" class="btn" @click="handleClickPause">暂停录音</el-button>
                        <el-button v-else class="btn" @click="handleClickResume">继续录音</el-button>
                    </p>
                    <el-button slot="two" class="btn upload" @click="handleClickStop">上传录音</el-button>
                </div>
            </div>
            <div v-if="index === 3" class="page-two">
                <ElementForm
                    ref="form"
                    :form.sync="newForm"
                />
                <p class="row"><span name="name">音频时长</span><span class="time">{{newTime}}</span>s</p>
                <p class="row"><span name="name">音频文件</span><span class="time el-icon-headset" @click="audioRecorderPlay"></span></p>
                <p class="btns">
                    <el-button class="btn upload active" @click="handleUpLoad">确认上传</el-button>
                </p>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import * as CommonServer from "../../../../../../../../../../api/common";
    export default {
        name: "luyin-dialog",
        props: {
            isShop: {
                type: Boolean,
                default: false
            },
            type: String,
            form: Array,
            time: {type:Number,default: 0},
            visible: {
                type: Boolean,
                default: true
            },
            optToBlockItem: [Array, Object]
        },
        filters: {
            filterTime(vl){
                if( vl>0 ){
                    return `${vl} s`
                } else {
                    return '- -'
                }
            }
        },
        computed: {
            getResourceCategoryTree(){
                return this.isShop?'getResourceCategoryShopTree':'getResourceCategoryTree'
            }
        },
        watch:{
            visible(vl){
                this.dialogVisible = vl
            },
            dialogVisible(vl){this.$emit('update:visible', vl)},
            time(vl){this.newTime = vl},
            newTime(vl){this.$emit('update:time', vl)},
            form(vl){this.newForm = vl},
            newForm(vl){this.$emit('update:form', vl)}
        },
        created() {
            this.init()
        },
        data(){
            return {
                step: 'initial',
                index: 1, // 当前tab
                isPlay: false, // 是否播放
                newTime: this.time,
                newType: this.type,
                dialogVisible: this.visible,
                newForm: [
                    {
                        attr: 'categoryId',
                        "name": "目录选择",
                        "value": [],
                        "type": "Cascader",
                        "style": "width:260px",
                        "props": {
                            size: 'small',
                            "placeholder": "请选择",
                            "rules": {
                                "required": true,
                                "message": "请选择",
                            }
                        },
                        options: []
                    },
                    {
                        'attr': 'name',
                        "name": "录音名称",
                        "value": "",
                        "type": "Input",
                        "props": {
                            size: 'small',
                            "placeholder": "请输入",
                            "rules": {
                                "required": true,
                                "message": "请输入",
                                "target": "blur"
                            }
                        }
                    }
                ]
            }
        },
        methods: {
            async init(){
                let obj = {
                    clientsId: this.$store.state.initConfig.school_id,
                    sort: 'audio'
                }
                const res = await CommonServer.default[this.getResourceCategoryTree](obj)
                console.log('res==>', res)
                let data = res.data
                let index = this.$utils.getIndexByAttr({attr: 'categoryId' ,data: this.newForm})
                this.newForm[index].options =  this.$utils.FormatData(data)
            },
            handleClickStart(){
                this.step = 'start'
                this.$emit('handleClickStart')
            },
            handleClickPause(){
                this.index = 2
                this.isPlay = true
                this.$emit('handleClickPause')
                this.$emit('fnTimeDestory')
            },
            audioRecorderPlay(){
                this.$emit('audioRecorderPlay')
            },
            handleClickResume(){
                this.index = 1
                this.step = 'start'
                this.isPlay = false
                this.$emit('handleClickResume')
                this.$emit('fnTimeStart')
            },
            handleClickStop(){
                this.index = 3
                this.$emit('handleClickStop')
                this.$emit('fnTimeDestory')
            },
            handleUpLoad(){
                let state = this.$refs.form.validateForm()
                if(state){
                    // 去上传
                    let obj = this.$utils.getObjByArr({data: this.newForm})
                    let categoryId = obj['categoryId']
                    if(Array.isArray(categoryId)){
                        obj['categoryId'] = categoryId[categoryId.length-1]
                    }
                    this.$emit('onLuyinDialog', obj)
                    // this.dialogVisible = false
                }
            },
            handleClose() {
                this.dialogVisible = false
                this.$emit('close')
            },
            submit() {
                let state = this.$refs.form.validateForm()
                state && this.handleClose()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .page-two /deep/ .el-cascader input{width: 177px;}
    .btns /deep/ .el-button:focus,
    .btns /deep/ .el-button:hover,
    .btns .active{
        color: white !important;
        border-color: #FF7838 !important;
        background: #FF7838 !important;
    }
    .el-icon-headset{
        cursor: pointer;
    }
    .page-one{
        display: flex;
        flex-direction: column;
        align-items: center;

        .img{
            width: 80px;
            height: 80px;

            &.cur{
                cursor: pointer;
            }
        }

        .row{
            font-size: 18px;
            padding: 20px 0px;
            color: #323232;

            .name{
                color: rgba(0, 0, 0, 0.35);
            }

            &.initial{
                color: rgba(0, 0, 0, 0.35);
            }
        }

        .btns {
            .start,.pause{
                cursor: pointer;
                font-size: 16px;
                font-weight: 500;
                color: #FF7838;
                line-height: 22px;
            }
        }
    }
    .row{
        .name{font-size: 14px;}
        .time{font-size: 16px;margin-left: 12px;margin-right: 6px}
    }
    .page-two{
        .row{
            padding-bottom: 10px;
            padding-left: 12px;
        }
    }
    .btns{
        width: 90%;
        margin-top: 10px;
        margin-bottom: 16px;
        display: flex;
        flex-direction: row;
        justify-content: center;

        .upload{
            margin-left: 30px;
        }
    }
    .luyin {
        background-color: #e7622e;
        border: none;
        outline: none;
        font-size: 18px;
        height: 40px;
        color: white;
        width: 160px;
        border-radius: 20px;

        &:active{
            opacity: .8;
        }
    }
</style>
